import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader"
import { ThemedText, ThemedView } from "@app/theme";
import { ScrollView } from "react-native";
import ShortFallBriefcase from "../../../assets/Icons/ShortfallBriefcase";
import Rupee from "../../../assets/Icons/Rupee";
import Button from "@app/sharedComponents/Button/Button";
import { checkColor } from "@app/utils";
import { useAppSelector } from "@app/store/hooks";

const WhatIsShortfall  = ({navigation,route}) =>{
      const {isfromTDL} = useAppSelector(state => state.platformParams);
    return(
        <>
            <PageHeaders pageName='WhatisShortfall?' navigation={navigation}/>
            <ScrollView style={{flex: 1, backgroundColor: '#fff',padding: 16}}>
                <ThemedText variant="b2s" color="text-primary" mb="xs">
                    What is shortfall?
                </ThemedText>
                <ThemedText variant="b3r" color="text-secondary">
                    Shortfall happens when credit limit drops below the outstanding amount.
                </ThemedText>
                <ThemedText variant="b3r" color="text-secondary" mt="md">
                    Credit limit may drop due to fall in market value of pledged portfolio.
                </ThemedText>
                <ThemedView height={1} width={'100%'} backgroundColor="border-primary" my="lg"/>
                <ThemedText color="text-primary" variant="b2s" mb="4xl">
                    What happens if you fail to meet shortfall?
                </ThemedText>
                <ThemedView flexDirection="row">
                    <ShortFallBriefcase {...isfromTDL && {color:checkColor('#1434CB')}}/>
                    <ThemedView ml="md" flexWrap="wrap" flex={1}>
                        <ThemedText variant="b3s" color="text-primary" mb="xs">
                            Portfolio sell-off to recover shortfall amount
                        </ThemedText>
                        <ThemedText variant="b4r" color="text-secondary" >
                            If payment is not done within 6 days, portfolio worth 2 times the shortfall amount will be sold-off
                        </ThemedText>
                    </ThemedView>
                </ThemedView>
                <ThemedView height={1} width={'100%'} backgroundColor="border-primary" my="lg"/>
                <ThemedView  flexDirection="row">
                <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={32} height={32} borderRadius="full" justifyContent="center" alignItems="center">

                        <Rupee color={checkColor('#1434CB')}/>
                    </ThemedView>
                    <ThemedView ml="md"  flexWrap="wrap" flex={1}>
                        <ThemedText variant="b3s" color="text-primary" mb="xs">
                            Impact on credit score
                        </ThemedText>
                        <ThemedText variant="b4r" color="text-secondary">
                        Not making payments on time can affect your credit score
                        </ThemedText>
                    </ThemedView>
                </ThemedView>
            </ScrollView>
            <ThemedView backgroundColor="bg-surface-primary" p="lg" alignItems="center" borderTopWidth={1} borderTopColor="border-primary">
                <Button label="Ok, got it!"  type="SOLID" size="MD"  handlePress={()=>navigation.goBack()}/>
            </ThemedView>
        </>
    )
}

export default WhatIsShortfall;